import 'arrayq';

import { applyHighlightSpan, removeHighlightElements } from '../abstractselection/index';
import { AnchorNode } from '../anchor/index';

export const applyHighlights = async (doc: AnchorNode, start: string, end: string, created: (node: HTMLSpanElement) => void) => {
    return await new Promise<Node[]>((resolve, reject) => {
        let count = 0;
        applyHighlightSpan(doc, start, end, (n) => { ++count; created(n); });
        if (count) {
            resolve();
        } else {
            reject(Error(`No matching node: ${start} - ${end}`));
        }
    });
};

export const removeHighlights = (baseNode: Element, selector: string) => {
    removeHighlightElements(baseNode, selector);
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/highlight/dom.tsx